<template>
  <v-container fluid>
    <v-form ref="form" @submit.prevent="save(false)">
      <v-row>
        <form-header :title="isEditing ?'Modifica sezione in home' : 'Nuovo sezione in home'"
                     @back="$router.replace('/home')" @saveback="save(true)" :loading="loading"></form-header>
        <v-col cols="12" >
          <h3>Info generali</h3>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <v-text-field label="Titolo*" v-model="editingItem.name.it" :rules="[rules.required]" ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <v-select label="Tipologia*" v-model="editingItem.type" :items="sectionTypes" :rules="[rules.required]" @update:model-value="editingItem.type_filter = undefined; editingItem.items = []"></v-select>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <v-text-field
              label="Numero elementi in sezione*" v-model="editingItem.max_items" :rules="[rules.required, rules.minInt(0)]"
              hint="0 = nessun limite" persistent-hint min="0" step="1" type="number"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <v-text-field label="Ordinamento*" v-model="editingItem.order" :rules="[rules.required, rules.minInt(1)]" type="number" min="1" step="1"></v-text-field>
        </v-col>

        <!-- genere -->
        <v-col cols="12" v-if="editingItem.type === 'genre'">
          <h3>Filtro per genere</h3>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3" v-if="editingItem.type === 'genre'">
          <v-select label="Seleziona il genere*" v-model="editingItem.type_filter" :items="genres" :rules="[rules.required]" ></v-select>
        </v-col>
        <!-- categoria -->
        <v-col cols="12" v-if="editingItem.type === 'category'">
          <h3>Filtro per categoria</h3>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3" v-if="editingItem.type === 'category'">
          <v-select label="Seleziona la categoria*" v-model="editingItem.type_filter" :items="categories" :rules="[rules.required]" ></v-select>
        </v-col>

        <!-- custom -->
        <v-col cols="12" v-if="editingItem.type === 'category'">
          <h3>Filtro per categoria</h3>
        </v-col>
        <v-col cols="12"  v-if="editingItem.type === 'custom'">
          <v-autocomplete label="Seleziona i pacchetti da visualizare*" v-model="editingItem.items" :items="kits" :rules="[rules.required]" multiple chips closable-chips></v-autocomplete>
        </v-col>



        <form-footer @back="$router.replace('/home')" @saveback="save(true)" :loading="loading"></form-footer>
      </v-row>
    </v-form>
  </v-container>
</template>

<script lang="ts">
import utils from "../utils";
import rules from "../utils/rules";
import FormHeader from "@/components/FormHeader.vue";
import FormFooter from "@/components/FormFooter.vue";
import {computed, inject, onMounted, ref, useTemplateRef} from "vue";
import type {Auth} from "@/plugins/auth.ts";
import {type Messages, Msg} from "@/plugins/messages.ts";
import type {Globals} from "@/plugins/globals.ts";
import {useRoute, useRouter} from "vue-router";
import api from "@/api";
import {VForm} from "vuetify/components";
import type { HomeSection } from "@/models.ts";
import {sectionTypes} from "@/consts.ts";
export default {
  components: {FormFooter, FormHeader},
  setup() {
    const auth = inject('auth') as Auth
    const messages = inject('messages') as Messages
    const globals = inject('globals') as Globals
    const route = useRoute()
    const router = useRouter()
    const form = useTemplateRef<typeof VForm>('form')
    const loading = ref(false)

    const editingItem = ref<HomeSection>({
      items: [], max_items: 0, name: {it:''}, order: 0, type: ""
    })

    const loadData = async () => {
      loading.value = true;
      let id = route.params.id as string;
      const res = await api.get<HomeSection>('home', id)
      if(!res.success) {
        loading.value = false;
        messages.error(res.message ?? Msg.serverError)
        await router.replace('/home')
        return
      }
      editingItem.value = res.data!
      loading.value = false;
    }

    onMounted(async ()=>{
      await globals.waitForInit
      await router.isReady()
      await Promise.all([
          globals.refreshEmpty('kits'),
          globals.refreshEmpty('genre'),
          globals.refreshEmpty('categories')
      ])
      if (route.params.id !== "new") {
        await loadData();
      }
    })




    return {
      form,
      loading,
      isEditing : computed(()=> route.params.id !== "new"),
      editingItem,
      sectionTypes,
      rules,
      formatDate : utils.formatDate,
      genres : computed(()=>{
        return globals.genre.value.map(i => {
          return { title : i.name.it, value : i._id}
        })
      }),
      categories: computed(()=> globals.categories.value.map(i => {
        return { title : i.name.it, value : i._id}
      })),
      kits: computed(()=> globals.kits.value.filter(i => i.pub).map(i => {
        return { title : i.title.it, value : i._id}
      })),
      async save(goBackAfterSave:boolean) {
        editingItem.value.max_items = utils.toInt(editingItem.value.max_items, 0)
        editingItem.value.order = utils.toInt(editingItem.value.order, 0)
        const v = await form.value!.validate()
        if(!v.valid) return;
        loading.value = true;
        const res = await api.save<HomeSection>('home', editingItem.value)
        loading.value = false;
        if(!res.success) {
          messages.error(res.message ?? Msg.serverError)
          if(res.status === 401) {
            auth.logout()
          }
          return
        }
        editingItem.value = res.data!
        messages.success("Sezione in home salvata")
        if(goBackAfterSave) {
          await router.replace('/home')
        } else if(route.params.id === 'new'){
          await router.replace(`/home/${editingItem.value._id}`)
        }
      }
    };
  }
};
</script>

<style scoped></style>
